import type { ReactNode } from 'react'

/** Grey placeholder rows shaped like the list that is coming (F4). Shown only while there is no data yet, never over data. */
export function Skeleton({ rows = 5, h = 56, card = true }: { rows?: number; h?: number; card?: boolean }) {
  const body = Array.from({ length: rows }, (_, i) => (
    <div key={i} className="skel-row" style={{ height: h }} aria-hidden="true">
      <span className="skel skel--dot" />
      <span className="skel skel--line" style={{ width: `${52 - (i % 3) * 11}%` }} />
      <span className="skel skel--end" />
    </div>
  ))
  return card ? <div className="card skel-card">{body}</div> : <>{body}</>
}

/** Placeholder tiles for the rack grid. */
export function SkeletonTiles({ n = 8 }: { n?: number }) {
  return (
    <div className="rack__grid" aria-hidden="true">
      {Array.from({ length: n }, (_, i) => (
        <div key={i} className="rack__item skel-tile"><span className="skel skel--img" /><span className="skel skel--line" style={{ width: '40%', margin: '10px 10px 0' }} /><span className="skel skel--line" style={{ width: '75%', margin: '6px 10px 4px' }} /></div>
      ))}
    </div>
  )
}

/** One empty-state pattern for every list: an icon, one line, and the thing to do next. */
export function Empty({ icon, line, action, onAction }: { icon?: ReactNode; line: ReactNode; action?: string; onAction?: () => void }) {
  return (
    <div className="emptystate">
      {icon && <div className="emptystate__icon">{icon}</div>}
      <div className="emptystate__line">{line}</div>
      {action && onAction && <button type="button" className="btn-secondary emptystate__btn" onClick={onAction}>{action}</button>}
    </div>
  )
}
